import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'

interface C806AnonymousLoginProps {
  execAnonymousLogin: (convId: string, password: string) => Promise<Result>
  loading: loadStatus
}
// C806 会話記録ログインAPI呼出
export const useC806AnonymousLogin = (): C806AnonymousLoginProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)

  const execAnonymousLogin = async (convId: string, password: string) => {
    try {
      setLoading(loadStatus.LOADING)
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader)
      // ボディ作成
      const body = { password: password }

      const response = await axios.post(
        `${baseUrl}${stage}${apiUrl.conversationsPath}${convId}/login`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execAnonymousLogin, loading }
}
